class r {
  constructor() {
  }
  validate(t) {
    return !!t.match(/^((http:\/\/)|(https:\/\/))?(www\.)?[a-zA-Z0-9-]{2,52}\.[a-zA-Z]{2,12}/);
  }
}
export {
  r as default
};
